<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 搜索框 -->
		<div class="titleView">
			<div style="display: flex;align-items: center;">
				<el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput"
					clearable size="small" />
				<el-button type="button" style="margin-left: 10px;" @click="handelSearchClick" size="small">搜索
				</el-button>
			</div>
			<div class="flex">
				<div class="m-r-10">预警门店</div>
				<el-select v-model="shop_id" placeholder="请选择" class="titleSelect" @change="handelSearchClick"
					size="small">
					<el-option v-for="item in store" :key="item.value" :label="item.label"
						:value="item.value" />
				</el-select>
			</div>
			<div class="flex">
				<div class="m-r-10">类型筛选</div>
				<el-select v-model="goodsType" placeholder="请选择" class="titleSelect" @change="handelSearchClick"
					size="small">
					<el-option v-for="item in goodsTypes" :key="item.value" :label="item.label"
						:value="item.value" />
				</el-select>
			</div>
			<div class="flex">
				<div class="m-r-10">商品状态</div>
				<el-select v-model="state" placeholder="请选择" class="titleSelect" @change="handelSearchClick"
					size="small">
					<el-option v-for="item in states" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</div>
			<div style="flex: 1;display: flex;justify-content: flex-end;">
				<el-button class="addClick" @click="handleResetClick" size="small">重置</el-button>
				<el-button class="addClick" @click="handleExportClick" size="small">导出</el-button>
				<el-button type="warning" class="addClick" @click="handleAddClick" size="small">发起采购</el-button>
			</div>
		</div>

		<!-- 表格 -->
		<div class="tableView">
			<el-table :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" :selectable="checkboxSelect">
				</el-table-column>
				<el-table-column prop="goodsName" label="商品名称" :key="1">
				</el-table-column>
				<el-table-column prop="skuValue" label="规格" :key="2">
					<template slot-scope="scope">
						{{scope.row.goodsType.id == '1' || scope.row.skuValue == ''?'--':FSkuName(scope.row.skuValue)}}
					</template>
				</el-table-column>
				<el-table-column prop="goodsType.name" label="类型" :key="3" width="60">
				</el-table-column>
				<el-table-column prop="unit" label="单位" :key="4" width="60">
				</el-table-column>
				<el-table-column prop="state.name" label="状态" :key="5" width="80">
				</el-table-column>
				<el-table-column label="停售时间" :key="6">
					<template slot-scope="scope">
						<span>{{scope.row.stopSaleTime == ''?'--':scope.row.stopSaleTime}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="minStock" label="最小库存" :key="7">
				</el-table-column>
				<el-table-column prop="allStock" label="总库存" :key="8">
				</el-table-column>
				<el-table-column label="当前库存/无库存时间" :key="9" width="140">
					<template slot-scope="scope">
						<div v-for="(item,index) in scope.row.currentStockData" :key="index">{{item.shopName}}:{{item.stock}}/{{item.noStockTime == ''?'--':item.noStockTime}}</div>
					</template>
				</el-table-column>
				<el-table-column label="总计销量/平均月销量/当前月销量" :key="10" width="240">
					<template slot-scope="scope">
						<div v-for="(item,index) in scope.row.saleSumData" :key="index">{{item.shopName}}:{{item.allSaleSum}}/{{item.avgSaleSum}}/{{item.nowMSaleSum}}</div>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
		<div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :total="page.total" :pageSize="page.pageSize" @change="changePage"></page>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import page from "../../../components/page.vue"
	export default {
		components: {
			page
		},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				keyword: '', //搜索
				fixedHeight: '',
				goodsType: -1, //类型筛选
				goodsTypes: [{ //线上线下列表
					label: '全部',
					value: -1,
				}, {
					label: '商品',
					value: 0
				}, {
					label: '药品',
					value: 1
				}],
				shop_id: '', //门店id
				store: [{ //门店列表
					label: '全部',
					value: ''
				}, {
					label: '北环店',
					value: '5e9412e0b2bfbc089daerr12'
				}, {
					label: '陇海店',
					value: '5e9412e0b2bfbc089daerr13'
				}, {
					label: '二七店',
					value: '5e9412e0b2bfbc089daerr16'
				}, {
					label: '东区店',
					value: '5e9412e0b2bfbc089daerr15'
				}, {
					label: '云尚店',
					value: '5e9412e0b2bfbc089daerr18'
				}],
				state: -2, //状态
				states: [{ //状态列表
					label: '全部',
					value: -2
				}, {
					label: '启用中',
					value: 1
				}, {
					label: '已暂停',
					value: 0
				}, {
					label: '已作废',
					value: -1
				}],
				tableData: [], //表格数据
				ids:[],  //id集合
				routeArr:[],  //跳转发起采购数据
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
			this.getTableData()
		},
		methods: {
			//是否禁用
			checkboxSelect(row){
				if(row.state.id == '1'){
					return true
				}else{
					return false
				}
			},
			//重置规格
			FSkuName(str) {
				let s = ''
				let arr = str.split(',')
				for (let i = 0; i < arr.length; i++) {
					s += arr[i].split(":")[1] + '，'
				}
				return s.substr(0, s.length - 1);
			},
			handleSelectionChange(val) {
				console.log('表格方法',val)
				let arr = [];
				let routeArr = [];
				for(let i = 0;i<val.length;i++){
					arr.push(val[i].skuId);
					routeArr.push({
						goodsType:val[i].goodsType.id,
						goodsId:val[i].goodsId,
						skuId:val[i].skuId,
						count:1
					})
				}
				this.ids = arr;
				this.routeArr = routeArr;
			},
			//发起采购
			handleAddClick(){
				console.log('所选id',this.ids)
				console.log('所选商品信息',this.routeArr)
				let params = {
					produceGoods:this.routeArr
				}
				this.$http.post(process.env.VUE_APP_caigou  + 'api/Procure/StockAlert/Create', params).then(res => {
					if (res.code == 0) {
						console.log('发起采购',res)
						let query = {
							routerMsg: res.data
						}
						this.$router.push({
							path: 'addcaigou',
							query
						})
					}
				})
			},
			//导出
			handleExportClick(){
				axios.get(process.env.VUE_APP_caigou +'api/Procure/UploadStockAlertInfo',{
					params:{
						goodsType:this.goodsType,
						state:this.state,
						shop_id:this.shop_id,
						page_index:this.page.page,
						page_size:this.page.pageSize,
						keyword:this.keyword
					},
					responseType: 'blob'
				}).then(response => {
					console.log(response)
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '预警列表导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
				}).catch(err => {
						console.log(err)
				})
			},
			//重置
			handleResetClick(){
				this.goodsType = -1;
				this.state = -2;
				this.shop_id = '';
				this.page.page = 1;
				this.keyword = '';
				this.getTableData()
			},
			//搜索
			handelSearchClick() {
				this.page.page = 1;
				this.getTableData()
			},
			// 分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			//表格
			getTableData() {
				let params = {
					goodsType:this.goodsType,
					state:this.state,
					shop_id:this.shop_id,
					page_index:this.page.page,
					page_size:this.page.pageSize,
					keyword:this.keyword
				}
				this.$http.post(process.env.VUE_APP_caigou  + 'api/Procure/StockAlert/List', params).then(res => {
					if (res.code == 0) {
						console.log('表格',res)
						this.tableData = res.data.data;
						this.page.total = res.data.count
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		padding: 16px 16px 65px 16px;
		height: 100%;
		box-sizing: border-box;
		position: relative;
	}

	.titleView {
		height: 72px;
		line-height: 72px;
		display: flex;
		background: #fff;
		align-items: center;
		border-radius: 6px;
		margin-bottom: 10px;
		font-size: 12px;
		padding: 0 10px;

		.titleInput {
			width: 130px;
		}

		.titleDate {
			width: 340px;
		}

		.titleSelect {
			width: 100px;
		}
	}

	.flex {
		display: flex;
		align-items: center;
		margin-left: 10px;
	}

	.m-r-10 {
		margin-right: 10px;
		font-size: 12px;
	}

	.tableView{
		padding: 16px;
		border-radius: 8px;
		background-color: #fff;
		box-sizing: border-box;
		height: calc(100% - 76px);
		overflow-y: scroll;
	}
	.pagePosi {
		position: absolute;
		bottom: 0;
		left: 16px;
		right: 16px;
		text-align: right;
		background-color: #fff;
		padding: 0 10px;
		border-radius: 8px 8px 0 0;
	}
</style>
